import firebase from '../../firebase.js';
import editImages from '../editImages/editImages.vue';
const db = firebase.firestore();
export default {
    name: 'blogPost',
    data() {
        return {
            dialog: false,
            fullPostDialog: false,
            show: false,
            body: this.$attrs.item.body,
            title: this.$attrs.item.title,
            date: this.$attrs.item.date,
            id: this.$attrs.item.id,
            imageDialog: false,
            imageSrc: '',
            images: this.$attrs.item.images,
            comments: this.$attrs.item.comments,
            newCommentDialog: false,
            errorSnackbar: false,
            editDialog: false,
            copiedSnackbar: false,
            newPost: this.$attrs.item,
            name: '',
            comment: '',
            snackbar: false,
            valid: false,
            commentSnackbar: false,
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 25 || 'Name must be less than 25 characters'
            ],
            commentRules: [
                v => !!v || 'Comment is required',
                v =>
                    v.length <= 150 ||
                    'Comment must be less than 150 characters'
            ]
        };
    },
    methods: {
        changePost() {
            this.newPost.ref
                .update({
                    title: this.newPost.title,
                    body: this.newPost.body,
                    images: this.newImages
                })
                .then(
                    function() {
                        this.editDialog = false;
                        this.title = this.newPost.title;
                        this.body = this.newPost.body;
                        this.images = this.newImages;
                    }.bind(this)
                );
        },
        copy() {
            var copyText = this.$refs.shareLink.$refs.input;
            copyText.select();
            document.execCommand('Copy');
            this.copiedSnackbar = true;
        },
        addComment() {
            if (this.$refs.form.validate()) {
                let item = this.$attrs.item;
                this.newCommentDialog = false;
                db.collection('/comments')
                    .add({
                        author: this.name,
                        body: this.comment,
                        approved: false,
                        post: item.ref,
                        timestamp: firebase.firestore.FieldValue.serverTimestamp()
                    })
                    .then(
                        function() {
                            this.commentSnackbar = true;
                        }.bind(this)
                    )
                    .catch(
                        function(error) {
                            console.error('Error writing document: ', error);
                            this.errorSnackbar = true;
                        }.bind(this)
                    );
                this.valid = true;
                this.$refs.form.reset();
                this.name = '';
                this.comment = '';
            }
        }
    },
    computed: {
        newImages() {
            return this.$refs.images.images;
        },
        link: function() {
            let location = window.location.host;
            location = location + '/blog/post-' + this.id;
            return location;
        },
        signedIn() {
            return this.$store.state.signedIn;
        },
        shortPost() {
            return this.body.replace(/^(.{200}[^\s]*).*/, '$1') + '...';
        },
        isImage: function() {
            if (this.images[0] != null) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        fullPostDialog: function(val) {
            if (val == true) {
                this.$router.push('/blog/post-' + this.id);
            } else {
                document.getElementById('navBar').style.marginTop = '0px';
                this.$router.push('/blog');
            }
        },
        $route: function(val) {
            if (val.path == '/blog' || val.path == '/blog') {
                this.fullPostDialog = false;
            } else if (val.path == '/blog/post-' + this.id) {
                this.fullPostDialog = true;
            }
        }
    },
    mounted() {
        let post = this.$route.params.post;
        if (post == 'post-' + this.$attrs.item.id) {
            setTimeout(
                function() {
                    this.fullPostDialog = true;
                }.bind(this),
                260
            );
        }
    },
    components: {
        editImages
    }
};



// WEBPACK FOOTER //
// ./src/components/post-card/post-card.js